// MainPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import NoItemsFound from '../components/NoItemsFound';
import DynamicTable from '../components/DynamicTable';
import TopBar from '../components/TopBar';
import TitleBackButton from '../components/TitleBackButton';
import Map from '../components/Map';
import { Link } from 'react-router-dom';

import {
  get_users,
  create_user,
  update_user,
  delete_user,
} from '../api/api';


import {
  getColumnDefs_user,
  getNewRowTemplate_user,
} from "../tables_config/tables_config.js";


const ProtectionPage = () => {

  const { item_id } = useParams();
  const [ page, setPage] = useState(1);
  const [ users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const newRowTemplate_user = getNewRowTemplate_user();


  const retrieveData = async () => {
    try{
        const get_the_users = async () => {
            const res = await get_users();
            const data = res && res.data && res.data.results ? res.data.results : [];
            setUsers(data);     // Set state with resolved data
        };
        await get_the_users();
      }
      catch(error){
            console.error(error);
      }
      finally {
            setLoading(false); // Set loading to false after the fetch is complete
      }
  }


  useEffect( () => {
      retrieveData();
  }, []);


  const setThePage = (page_id)=>{
    setPage(page_id);
  }

  return (
    <div>
      <TopBar />

      <div className="content">

            <TitleBackButton
              title={"Pannello Admin"}
            />

        <div className="main-content">

          <div className="admin-table-outer">

                {loading ? (
                    <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
                ) : (
                    <DynamicTable
                    items={users}
                    labelAddNew="utente"
                    hasMap={false}
                    callbackShowMap={()=>{}}
                    callbackHideMap={()=>{}}
                    createFunction={create_user}
                    updateFunction={update_user}
                    deleteFunction={delete_user}
                    getColumnDefs={getColumnDefs_user}
                    newRowTemplate={newRowTemplate_user}
                    columnKey={'first_name'}
                    showTransactionModal={true}

                  />
                ) }
            </div>

        </div>

      </div>
    </div>
  );
};

export default ProtectionPage;
